import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import type { AnyAction } from 'redux'
import type { ThunkDispatch } from 'redux-thunk'
import { useStyles } from './StepsLabraApp.styles'
import { BoxV2, ExternalLink, ButtonV2 } from '@labrav/react-components'
import { faSquareSliders } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import { isLoading } from '../../utils/loadingState'
import { LoadingTypes } from '../../modules/loading/reducer'
import { checkCrmConnection } from '../../modules/crmAuth/crmConnectionActions'
import { useOnboardingTenantPartnerId } from '../../utils/hooks/useCrmOnboardingContext'
import type { CrmOnboardingRootState } from '../../modules/crmSelector/crmOnboardingState'
const StepsLabraApp: React.FC<{ appLink: string }> = ({ appLink }) => {
  const { classes } = useStyles()
  const dispatch =
    useDispatch<ThunkDispatch<CrmOnboardingRootState, unknown, AnyAction>>()
  const partnerId = useOnboardingTenantPartnerId()
  const crmFormData = useSelector(
    (state: CrmOnboardingRootState) =>
      state.CRMAuth.crmFormData ? state.CRMAuth.crmFormData : undefined
  )

  const loading = useSelector((state: CrmOnboardingRootState) =>
    isLoading(state.loading)(LoadingTypes.CRM_CONNECTION)
  )

  const crmConnection = useSelector(
    (state: CrmOnboardingRootState) => state.CRMAuth.crmConnection
  )

  const checkConnection = async () => {
    if (partnerId && crmFormData?.crm_id) {
      dispatch(checkCrmConnection(partnerId, crmFormData.crm_id))
    }
  }

  return (
    <BoxV2
      heading="How to install and integrate Labra automation app"
      headingIcon={
        <FontAwesomeIcon
          icon={faSquareSliders}
          style={{ height: '20px', width: 14 }}
        />
      }
    >
      <div
        data-testid="steps_to_install"
        className={`${classes.steps} ${classes.text}`}
      >
        <div className={classes.row}>
          <div className={classes.stepBubble}> Step 1</div>
          <span className={classes.inline}>
            Install our app from{' '}
            <ExternalLink
              className={clsx(classes.text, classes.linkText)}
              href={appLink}
            >
              here
            </ExternalLink>
          </span>
        </div>
        <div className={classes.row}>
          <div className={classes.stepBubble}>Step 2</div>
          <div className={classes.columns}>
            <div className={classes.lineText}>
              <span className={classes.inline}>
                Copy API details (CRM ID, Secret key and Client ID) from{' '}
                <ExternalLink
                  className={clsx(classes.text, classes.linkText)}
                  href={'/settings/app-settings'}
                >
                  here
                </ExternalLink>
              </span>
            </div>
            <div>
              Paste on the quick onboarding setup inside Salesforce Labra app.
            </div>
          </div>
        </div>
        <div>
          {!crmConnection && (
            <ButtonV2
              data-testid="check-connection-button"
              styleType="primary"
              onClick={checkConnection}
              disabled={loading}
            >
              Check connection
            </ButtonV2>
          )}
        </div>
        <div className={classes.divider} />
        <div className={classes.lineText}>
          <span className={classes.inline}>
            If you have already installed it, you can update your Labra
            automation app from{' '}
            <ExternalLink
              className={clsx(classes.text, classes.linkText)}
              href={appLink}
            >
              here
            </ExternalLink>
          </span>
        </div>
      </div>
    </BoxV2>
  )
}

export default StepsLabraApp
